import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mapbox/mr-ui/icon';

class DownloadButton extends React.Component {
  render() {
    return (
      <div className="col col--6-mm">
        <a
          href={this.props.href}
          ref={this.props.ref}
          className={this.props.className}
        >
          <Icon themeIcon="mr6" name="arrow-down" inline={true} />
          {this.props.label}
        </a>
      </div>
    );
  }
}

DownloadButton.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  tag: PropTypes.string
};

export { DownloadButton };
